import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faCalendarAlt,
  faMapMarkerAlt,
  faUser,
  faEdit,
} from "@fortawesome/free-solid-svg-icons";
import {
  faSpotify,
  faApple,
  faYoutube,
  faInstagram,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { Link } from "react-router-dom";
import UrlBox from "./UrlBox";

const ArtistProfilePage = ({
  user,
  socialHeading,
  privateMode,
  editProfile,
  children,
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-gray-800 text-white p-6">
      <div className="max-w-4xl mx-auto bg-gray-900 shadow-lg rounded-lg p-6 relative">
        {editProfile && (
          <div className="absolute right-0 top-6 hover:text-yellow-800 hover:cursor-pointer z-50">
            <Link to={editProfile}>
              <FontAwesomeIcon icon={faEdit} size="xl" />
            </Link>
          </div>
        )}
        <div className="flex items-center space-x-6 flex-wrap xsm:flex-nowrap justify-center xsm:justify-start">
          <div className="w-32 h-32 rounded-full overflow-hidden border-4 border-yellow-500">
            {user.image ? (
              <img
                src={user.image}
                alt="Artist"
                className="w-full h-full object-cover"
              />
            ) : (
              <span className="text-6xl capitalize font-semibold text-yellow-500 flex items-center justify-center w-full h-full bg-gray-700">
                {user.stageName?.charAt(0)}
              </span>
            )}
          </div>
          <div>
            <h2 className="text-4xl font-bold capitalize">{user.stageName}</h2>
            <p className="text-yellow-400 text-lg">
              {user.genre?.join(", ") || "Unknown Genre"}
            </p>
            <p className="text-gray-300 text-justify">
              {user.bio || "No bio available"}
            </p>
          </div>
        </div>
      </div>

      {!privateMode ? (
        <div className="max-w-4xl mx-auto mt-6 bg-gray-900 shadow-md p-4 rounded-lg">
          <h3 className="text-xl font-semibold mb-3 text-yellow-400">
            Personal Information
          </h3>
          <ul className="space-y-3">
            <li className="flex items-center">
              <FontAwesomeIcon icon={faUser} className="mr-2 text-yellow-500" />{" "}
              {user.fullName?.fName} {user.fullName?.lName}
            </li>
            <li className="flex items-center">
              <FontAwesomeIcon
                icon={faEnvelope}
                className="mr-2 text-yellow-500"
              />{" "}
              {user.email}
            </li>
            <li className="flex items-center">
              <FontAwesomeIcon
                icon={faCalendarAlt}
                className="mr-2 text-yellow-500"
              />{" "}
              {user.dob?.split("T")[0] || "NA"}
            </li>
            <li className="flex items-center">
              <FontAwesomeIcon
                icon={faMapMarkerAlt}
                className="mr-2 text-yellow-500"
              />{" "}
              {user.address?.state}, {user.address?.country}
            </li>
          </ul>
        </div>
      ) : null}

      {children && (
        <div className="max-w-4xl mx-auto mt-6 bg-gray-900 shadow-md p-4 rounded-lg">
          {children}
        </div>
      )}

      <div className="max-w-4xl mx-auto mt-6 bg-gray-900 shadow-md p-4 rounded-lg">
        
      {
        <div className="max-w-4xl mx-auto shadow-md rounded-lg">
          <h6 className="text-sm mb-1 mt-2 text-yellow-400">My Fan Page</h6>
          <UrlBox text={`fanpage/${user.username}`} />
        </div>
      }
        <h3 className="text-sm text-center font-semibold mb-3 text-yellow-400">
          {!socialHeading && "Follow & Listen"}
        </h3>
        <div className="flex space-x-4 justify-center">
          <a href={user.spotify} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon
              icon={faSpotify}
              className="text-green-500 text-3xl hover:text-green-400"
            />
          </a>
          <a href={user.appleMusic} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon
              icon={faApple}
              className="text-green-500 text-3xl hover:text-green-400"
            />
          </a>
          <a href={user.youtube} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon
              icon={faYoutube}
              className="text-green-500 text-3xl hover:text-green-400"
            />
          </a>
          <a href={user.instagram} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon
              icon={faInstagram}
              className="text-green-500 text-3xl hover:text-green-400"
            />
          </a>
          <a href={user.twitter} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon
              icon={faTwitter}
              className="text-green-500 text-3xl hover:text-green-400"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default ArtistProfilePage;
